<template>
    <div class="our-partners">
        <h2 class="intro">Thank you to the various companies that continue to help and support us</h2>
        <ul class="w-100 d-flex flex-wrap justify-content-center"  aria-label="Partners List">
            <li class="item" v-for="partner in randomPartners" :key="partner.title" >
                <a :href="partner.website" target="_blank" role="link" :aria-label="partner.title">
                    <div class="item-content">
                        <img class="logo" :src="partner.img" :alt="partner.title">
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {

        data(){
            return {
                partners: [
                    {title : 'NALMCO', img: '/images/partners/nalmco.png', website: 'https://www.nalmco.org'},
                    {title : 'Walters', img: '/images/partners/walters.png', website: 'https://www.walterswholesale.com'},
                    {title : 'Leviton', img: '/images/partners/leviton.png', website: 'http://leviton.com'},
                    {title : 'OSHA', img: '/images/partners/osha.png', website: 'https://www.osha.gov'},
                    {title : 'NFPA', img: '/images/partners/nfpa.png', website: 'https://www.nfpa.org'},
                    {title : 'nLight', img: '/images/partners/nlight.jpg', website: 'http://www.nlight.net'},
                    {title : 'ABC', img: '/images/partners/abc.jpg', website: 'https://www.abc.org'},
                    {title : 'Lutron', img: '/images/partners/lutron.png', website: 'http://www.lutron.com'},
                    {title : 'California Energy Comission', img: '/images/partners/energy-commision.png', website: 'https://www.energy.ca.gov'},
                    {title : 'California Energy Alliance', img: '/images/partners/cal_energy_alliance.png', website: 'https://caenergyalliance.org'},
                    {title : 'Energy Code Ace', img: '/images/partners/ec_ace.png', website: 'https://energycodeace.com'},
                    {title : 'Lighting Controls Association', img: '/images/partners/lca.png', website: 'http://lightingcontrolsassociation.org'},
                    {title : 'Performance Lighting Systems', img: '/images/partners/performance.png', website: 'http://performanceltg.com'},
                    {title : 'Wester Lighting & Energy Controls', img: '/images/partners/western.png', website: 'https://westernlightingandenergycontrols.com'},
                    {title : 'California Electrical Training', img: '/images/partners/cet.png', website: 'https://californiaelectricaltraining.com'},
                ]
            }
        },

        computed:{
            randomPartners(){
                return _.shuffle(this.partners);
            }
        }
    }
</script>